import React, { useState, useEffect } from 'react';
import { Card } from '@uhg-abyss/web/ui/Card';
import { styled } from '@uhg-abyss/web/tools/styled';
import PropTypes from 'prop-types';
import { coveo } from '@src/tools/coveo';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';
import { PagerBottom } from './PagerBottom';
import { PagerTop } from './PagerTop';
import { ResultLink } from './ResultLink';

const SpaceBetween = styled('div', {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
});
const LoadingContainer = styled('div', {
  height: '500px',
});

export const ResultList = ({
  controller,
  searchTerm,
  headlessEngine,
  facets,
  isFacetSelected,
  setIsFacetSelected,
  selectedFacets,
  setSelectedFacets,
}) => {
  const [resultState, setResultState] = useState(controller.state);
  const { getMessage } = usePPDLagoon();
  const defaultErrorMessage = getMessage('default-error');

  useEffect(() => {
    controller.subscribe(() => setResultState(controller.state));
  }, [controller]);

  return (
    <div>
      <Choose>
        <When
          condition={
            controller.state.isLoading ||
            headlessEngine?.state?.search?.isLoading ||
            headlessEngine?.state?.search?.error?.type
          }
        >
          <LoadingContainer>
            <LoadingOverlay
              loadingTitle='Please Wait'
              loadingMessage={`searching for '${searchTerm}'`}
              isLoading={
                controller.state.isLoading ||
                headlessEngine.state.search.isLoading
              }
              isOpen={headlessEngine?.state?.search?.error?.type}
              statusMessage={defaultErrorMessage}
              statusIcon='warning'
            />
          </LoadingContainer>
        </When>
        <Otherwise>
          <Card>
            <Card.Section>
              <SpaceBetween>
                <PagerTop
                  controller={coveo.controllers.pager(headlessEngine)}
                  searchTerm={searchTerm}
                  headlessEngine={headlessEngine}
                  facets={facets}
                  isFacetSelected={isFacetSelected}
                  setIsFacetSelected={setIsFacetSelected}
                  selectedFacets={selectedFacets}
                  setSelectedFacets={setSelectedFacets}
                />
              </SpaceBetween>
            </Card.Section>
            <For each='result' of={resultState.results} index='index'>
              <ResultLink
                headlessEngine={headlessEngine}
                result={result}
                index={index}
              />
            </For>
            <Card.Section>
              <SpaceBetween>
                <PagerBottom
                  controller={coveo.controllers.pager(headlessEngine)}
                  headlessEngine={headlessEngine}
                />
              </SpaceBetween>
            </Card.Section>
          </Card>
        </Otherwise>
      </Choose>
    </div>
  );
};

ResultList.propTypes = {
  controller: PropTypes.shape({
    state: PropTypes.shape({
      results: PropTypes.arrayOf(PropTypes.shape({})),
      isLoading: PropTypes.bool,
    }),
    subscribe: PropTypes.func.isRequired,
  }),
  searchTerm: PropTypes.string,
  headlessEngine: PropTypes.shape({
    state: {
      search: PropTypes.shape({}),
    },
  }).isRequired,
  facets: PropTypes.arrayOf(PropTypes.shape({})),
  isFacetSelected: PropTypes.bool.isRequired,
  setIsFacetSelected: PropTypes.func.isRequired,
  selectedFacets: PropTypes.arrayOf(PropTypes.shape({})),
  setSelectedFacets: PropTypes.func.isRequired,
};

ResultList.defaultProps = {
  controller: {
    state: {
      results: [],
      isLoading: false,
    },
  },
  searchTerm: '',
  facets: [],
  selectedFacets: [],
};
